import { DownloadOutlined, EditOutlined, PrinterOutlined, SaveOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Divider, FloatButton, Form, Input, Modal, Radio, Row, Space, Tabs, Tag, Upload, UploadFile } from 'antd';
import { RcFile, UploadProps } from 'antd/es/upload';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { defaultAvatarImg, responseStatus, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { dateCommon, formatVND, thoiGianCongTacCommon } from '../../helpers/common';
import { BacLuongResponse, ChiTietHopDongResponse } from '../../models/hopdong/HopDong';
import { LuuAnhDaiDienResponse, NhanVienResponse } from '../../models/nhanvien/NhanVien';
import LoadingDetailPage from '../../modules/loading/LoadingDetailPage';
import { layCTHopDong, layDsHopDongTheoIdNhanVien } from '../../services/hopdong';
import { layCTNhanVien, luuAnhDaiDien } from '../../services/nhanvien';
import { xuatBaoCaoChiTietNhanVienMoi } from '../../services/report';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import ChungChiBox from '../nhanvien/ChungChiBox';
import InHoSoNhanVienMoi from '../nhanvien/InHoSoNhanVienMoi';
import KhenThuongBox from '../nhanvien/KhenThuongBox';
import KyLuatBox from '../nhanvien/KyLuatBox';
import NguoiPhuThuocBox from '../nhanvien/NguoiPhuThuocBox';
import QuaTrinhDaoTaoVaHocVanBox from '../nhanvien/QuaTrinhDaoTaoVaHocVanBox';
import QuaTrinhLamViecVaCongTacBox from '../nhanvien/QuaTrinhLamViecVaCongTacBox';
import { menuHelper } from '../../helpers/account';
import DanhGiaXepLoaiBox from '../nhanvien/DanhGiaXepLoaiBox';

const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });

const XemHoSoCaNhan = () => {
    let navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(true);
    const [openModalXuatFile, setOpenModalXuatFile] = useState(false);
    const [loaiMauXuat, setLoaiMauXuat] = useState<number>(2);
    const [nhanVien, setNhanVien] = useState<NhanVienResponse>(new NhanVienResponse);
    const [anhDaiDien, setAnhDaiDien] = useState<LuuAnhDaiDienResponse>(new LuuAnhDaiDienResponse);
    const [hopDongInfo, setHopDongInfo] = useState<ChiTietHopDongResponse>(new ChiTietHopDongResponse);
    const [bacLuongInfo, setBacLuongInfo] = useState<BacLuongResponse>(new BacLuongResponse);
    const [trangThai, setTrangThai] = useState<number>(-1);
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [openModalLuu, setOpenModalLuu] = useState(false);
    const menu: any = menuHelper.checkMultiPermission([Links.HoSoCaNhan.SuaDayDu, Links.HoSoCaNhan.SuaCoBan]);
    const layDuLieu = async (id: number) => {
        setLoading(true);
        try {
            let kq = await layCTNhanVien(id);
            setNhanVien(kq);
            setAnhDaiDien(kq);
            form.setFieldsValue({
                doiAvatar: 0,
            })
            setTrangThai(kq.trangThai);
            setLoading(false);
            if (kq.avatar != null && kq.avatar.length > 0) {
                setFileList([{
                    uid: '-1',
                    name: 'image.png',
                    status: 'done',
                    url: urlAdmin + kq.avatar.replace(/\\/g, "/"),
                }]);
            }
        } catch (err) {
            toast.error('Nhân viên không tồn tại');
            navigate(Links.NhanVien.DanhSach);
            setLoading(false);
        }
    }

    const xuatBaoCao = async (idNhanVien: number, hoTen: string, loaiMau: number = 2) => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatBaoCaoChiTietNhanVienMoi(idNhanVien, loaiMau);
            let link = document.createElement('a');

            link.download = loaiMau === 2 ? `SoYeuLyLich_2C_${hoTen}.docx` : `${hoTen}.docx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            setOpenModalXuatFile(false);
            dispatch(hideLoadingScreen());
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    const layChiTietHopDong = async (idNV: number) => {
        try {
            if (idNV > 0) {
                var rs = await layDsHopDongTheoIdNhanVien(idNV);
                if (rs.dsHopDong.length > 0) {
                    var selectDefault = rs.dsHopDong.find(x => x.trangThai === 1) || rs.dsHopDong[0];
                    if (selectDefault.id > 0) {
                        var data = await layCTHopDong(selectDefault.id);
                        setHopDongInfo(data);
                        if (data.bacLuong.length > 0) {
                            setBacLuongInfo(data.bacLuong[0]);
                        }
                    }
                }
            }
        }
        catch (error: any) {
            toast.error('Có lỗi xảy ra, hãy thử lại sau!')
            navigate(Links.HopDong.DanhSach);
        }
    };

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileList, setFileList] = useState<UploadFile[]>([
    ]);

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };

    const [editingMode, setEditingMode] = useState(false);
    const handleEdit = () => {
        setEditingMode(true);
    };

    const handleSave = () => {
        setOpenModalLuu(true);
    };


    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        if (form.getFieldValue('doiAvatar') == 0) {
            form.setFieldValue('doiAvatar', 1);
        }
    }

    const onSave = () => {
        form.validateFields().then(async (values) => {
            try {

                dispatch(showLoadingScreen());
                var data = {
                    id: anhDaiDien?.id || null,
                    hinhAnh: fileList.length > 0 ? fileList[0].originFileObj : null,
                    ...values
                };
                var response: any = await luuAnhDaiDien(data);
                if (response.trangThai === responseStatus.thanhCong) {
                    setOpenModalLuu(false);
                    setReload(true);
                    toast.success("Lưu sửa ảnh thành công");
                    setEditingMode(false);
                } else {
                    toast.error(response.thongBao);
                }
                dispatch(hideLoadingScreen());
            } catch (error: any) {
                toast.error(error || 'Có lỗi xảy ra');
                dispatch(hideLoadingScreen());
            }
        });
    }

    const componentRef = React.createRef<any>();

    const inBaoCao = useReactToPrint({
        content: () => componentRef.current,
    });

    useEffect(() => {
        if (reload) {
            setReload(false); 
            layDuLieu(user.idNhanVien);
            layChiTietHopDong(user.idNhanVien);
        }
    }, [reload]);

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case 4: tag = (<Tag color="success">Đã nghỉ hưu</Tag>); break;
        case 1: tag = (<Tag color="processing">Đang làm việc</Tag>); break;
        case 2: tag = (<Tag color="warning">Biệt phái</Tag>); break;
        case 3: tag = (<Tag color="error">Đã nghỉ việc</Tag>); break;
    }

    if (loading) {
        return (
            <LoadingDetailPage title="Hồ sơ cá nhân" />
        );
    }
    return (<section style={{ paddingBottom: "52px" }}>
        <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
        {openModalLuu && <ModalTextForm show={openModalLuu}
            title="Lưu thông tin"
            handleClose={() => setOpenModalLuu(false)}
            handleSave={onSave}>
            Xác nhận lưu ảnh
        </ModalTextForm>}
        <ContentHeader title="Hồ sơ cá nhân" />
        <Row >
            <Col span="24">
                <Form form={form}>
                <Tabs
                    defaultActiveKey="1" items={[
                        {
                            key: '1',
                            label: 'Thông tin cá nhân',
                            children:
                                <div className="card pt-3 pb-2">
                                    <div className="tab-content">
                                        <Row>
                                            <Col span="6">
                                                <div className="text-center mb-3 mt-5">
                                                    <SwitchTransition>
                                                        <CSSTransition key={editingMode ? 'upload' : 'image'} classNames="fade" timeout={300}>
                                                            {editingMode ? (
                                                                <Upload
                                                                    className="profile-user-img img-fluid img-circle"
                                                                    listType="picture-card"
                                                                    accept=".png, .jpg, .jpeg"
                                                                    fileList={fileList}
                                                                    onPreview={handlePreview}
                                                                    onChange={handleChange}
                                                                    beforeUpload={() => false}
                                                                >
                                                                    {fileList.length === 0 && '+ Thêm ảnh'}
                                                                </Upload>
                                                            ) : (
                                                                <img
                                                                    className="profile-user-img img-fluid img-circle"
                                                                    style={{ marginBottom: "15px"}}
                                                                    src={
                                                                        nhanVien?.avatar == null || nhanVien?.avatar === ""
                                                                            ? defaultAvatarImg
                                                                            : `/${nhanVien?.avatar.replace(/\\/g, "/")}`
                                                                    }
                                                                    alt="User profile picture"
                                                                />
                                                            )}
                                                        </CSSTransition>
                                                    </SwitchTransition>
                                                    <div >
                                                    <SwitchTransition>
                                                        <CSSTransition key={editingMode ? 'save' : 'edit'} classNames="fade" timeout={300}>
                                                            {editingMode ? (
                                                                    <Button onClick={handleSave} icon={<SaveOutlined rev="" />} type="primary">
                                                                    Lưu
                                                                </Button>
                                                            ) : (
                                                                     <Button onClick={handleEdit} icon={<EditOutlined rev="" />} className="hrm-btn-warning">
                                                                    Chỉnh sửa
                                                                </Button>
                                                            )}
                                                        </CSSTransition>
                                                </SwitchTransition>
                                                    </div>
                                                </div>
                                                <Form.Item hidden name="doiAvatar"><Input /></Form.Item>
                                            </Col>
                                            <Col span="4">
                                                <div className="mb-1">
                                                    <div>Tên nhân viên</div>
                                                    <label>{nhanVien.hoTen}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Tình trạng hôn nhân</div>
                                                    <label>{nhanVien?.isKetHon ? "Đã kết hôn" : "Chưa kết hôn"}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Email</div>
                                                    <label>{nhanVien?.email}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Quốc tịch</div>
                                                    <label>{nhanVien?.tenQuocTich}</label>
                                                </div>
                                            </Col>
                                            <Col span="4">
                                                <div className="mb-1">
                                                    <div>Giới tính</div>
                                                    <label>{nhanVien?.gioiTinh === 0 ? "Nam" : "Nữ"}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Ngày sinh</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ngaySinh)}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Điện thoại</div>
                                                    <label>{nhanVien?.dienThoai}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Dân tộc</div>
                                                    <label>{nhanVien?.tenDanToc}</label>
                                                </div>
                                            </Col>
                                            <Col span="5">
                                                <div className="mb-1">
                                                    <div>Tôn giáo</div>
                                                    <label>{nhanVien?.tenTonGiao}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Số CMND/CCCD</div>
                                                    <label>{nhanVien.cccd}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Ngày cấp CCCD</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ngayCapCCCD)}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Nơi cấp CMND/CCCD</div>
                                                    <label>{nhanVien.noiCapCCCD}</label>
                                                </div>

                                            </Col>
                                            <Col span={5}>
                                                <div className="mb-1">
                                                    <div>Nơi sinh</div>
                                                    <label>{nhanVien?.noiSinh}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Quê quán</div>
                                                    <label>{nhanVien?.queQuan}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Số tài khoản</div>
                                                    <label>{nhanVien?.soTKNganHang}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Ngân hàng</div>
                                                    <label>{nhanVien?.tenNganHang}</label>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span="6"></Col>
                                            <Col span="4">
                                                <div className="mb-1">
                                                    <div>Trình độ văn hóa</div>
                                                    <label>{nhanVien?.tenTrinhDoVanHoa}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Trình độ học vấn</div>
                                                    <label>{nhanVien?.tenHocHam}</label>
                                                </div>
                                            </Col>
                                            <Col span="4">
                                                <div className="mb-1">
                                                    <div>Mã số thuế</div>
                                                    <label>{nhanVien?.maSoThue}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Số BHXH</div>
                                                    <label>{nhanVien?.soBHXH}</label>
                                                </div>
                                            </Col>
                                            <Col span="10">
                                                <div>
                                                    <div>Nơi ở hiện tại</div><label>
                                                        {[
                                                            nhanVien?.soNhaNoiO,
                                                            nhanVien?.tenPhuongXaNoiO,
                                                            nhanVien?.tenTinhThanhNoiO
                                                        ]
                                                            .filter(x => x)
                                                            .join(", ")}
                                                    </label>
                                                </div>
                                                <div>
                                                    <div>Nơi thường trú</div>
                                                    <label>
                                                        {[
                                                            nhanVien?.soNhaThuongTru,
                                                            nhanVien?.tenPhuongXaThuongTru,
                                                            nhanVien?.tenTinhThanhThuongTru
                                                        ]
                                                            .filter(x => x)
                                                            .join(", ")}
                                                    </label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                        },
                    ]}>
                    </Tabs>
                </Form>
            </Col>
        </Row>
        <Row >
            <Col span="24">
                <Tabs defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Tài liệu hồ sơ cá nhân',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px" }}>
                                    <Row>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Trạng thái</div>
                                                <label>{nhanVien?.fileHoSoCaNhan ? <Tag color="success">Đã có</Tag> : <Tag color="error">Chưa có</Tag>}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Thông tin file</div>
                                                {nhanVien.fileHoSoCaNhan ? (
                                                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 6 }}>
                                                        <PaperClipOutlined />
                                                        <a href={urlAdmin + nhanVien.fileHoSoCaNhan.duongDan.replace(/\\/g, "/")} target="_blank" rel="noreferrer">
                                                            {nhanVien.fileHoSoCaNhan.tenTep}
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <span style={{ color: '#999' }}>Chưa có hồ sơ</span>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                    },
                ]}>
                </Tabs>
            </Col>
        </Row>
        <Row >
            <Col span="24">
                <Tabs defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Thông tin công việc',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px" }}>
                                    <Row>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Trạng thái</div>
                                                <label>{tag}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Ngày vào làm</div>
                                                <label>{dateCommon.formatDate(nhanVien?.ngayVaoLam)}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <Row>
                                                <Col span="12">
                                                    <div className="mb-1">
                                                        <div>Ngày tính phép</div>
                                                        <label>{dateCommon.formatDate(nhanVien?.ngayTinhPhep)}</label>
                                                    </div>
                                                </Col>
                                                <Col span="12">
                                                    <div className="mb-1">
                                                        <div>Thời gian làm CQNN </div>
                                                        <label>{thoiGianCongTacCommon.hienThi(nhanVien?.soThangLamCQNN)}</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span="8">
                                            {(nhanVien.trangThai == 0 || nhanVien.trangThai == 3) &&
                                                <div>
                                                    <div>Ngày nghỉ việc</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ngayNghiViec)}</label>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Phòng ban</div>
                                                <label>{nhanVien?.tenDonVi}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Chức danh chuyên môn</div>
                                                <label>{nhanVien?.tenChucDanhChuyenMon}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div>
                                                <div>Chức vụ</div>
                                                <label>{nhanVien?.tenChucVu}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Trình độ LLCT</div>
                                                <label>{nhanVien?.tenTrinhDoLLCT}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Nhóm nhân sự</div>
                                                <label>{nhanVien?.tenNhomNhanSu}</label>
                                            </div>
                                            <div>
                                                <div>Số sổ BHXH</div>
                                                <label>{nhanVien?.soBHXH}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                    },
                ]}>
                </Tabs>
            </Col>
        </Row>
        <Row >
            <Col span="24">
                <Tabs defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Thông tin hợp đồng/Quyết định bổ nhiệm',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px", marginRight: "20px" }}>
                                    <Row>
                                        <Col span="6">
                                            <div>Số hợp đồng/Quyết định bổ nhiệm</div>
                                            <label>
                                                <Space>
                                                    <span style={{ display: 'none' }}>{hopDongInfo?.soHopDong}</span>
                                                    <Tag color={hopDongInfo?.trangThai ? "green" : "red"}>{hopDongInfo?.trangThai ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                                                </Space>
                                            </label>
                                            <div>Từ ngày</div>
                                            <label>{dateCommon.formatDate(hopDongInfo?.ngayBatDau)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Loại hợp đồng/Quyết định bổ nhiệm</div>
                                            <label>{hopDongInfo?.loaiHopDong}</label>
                                            <div>Đến ngày</div>
                                            <label>{dateCommon.formatDate(hopDongInfo?.ngayKetThuc)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Ngày ký</div>
                                            <label>{dateCommon.formatDate(hopDongInfo?.ngayKy)}</label>
                                            <div>Người ký</div>
                                            <label>{hopDongInfo?.tenNguoiKy}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Nơi ký</div>
                                            <label>{hopDongInfo?.noiKy}</label>
                                            <div>Đóng BHXH</div>
                                            <label><Tag color={hopDongInfo?.isDongBHXH ? "green" : "red"}>{hopDongInfo?.isDongBHXH ? "Đóng" : "Không đóng"}</Tag></label>
                                        </Col>
                                    </Row>
                                    <Divider orientation="left" style={{ fontSize: "15px" }}>Quyết định bậc lương</Divider>
                                    <Row>
                                        <Col span="6">
                                            <div>Số quyết định bậc lương</div>
                                            <label>{bacLuongInfo.soQD}</label>
                                            <div>Từ ngày</div>
                                            <label>{dateCommon.formatDate(bacLuongInfo.ngayBatDau)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Hệ số</div>
                                            <label>{bacLuongInfo.heSo}</label>
                                            <div>Đến ngày</div>
                                            <label>{dateCommon.formatDate(bacLuongInfo.ngayKetThuc)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Mức lương</div>
                                            <label>{formatVND(bacLuongInfo.mucLuong)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Ngày ký quyết định</div>
                                            <label>{dateCommon.formatDate(bacLuongInfo.ngayKyQD)}</label>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                    },
                    {
                        key: '2',
                        label: 'Thông tin Đảng',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px" }}>
                                    <Row>
                                        <Col span="24">
                                            <div className="mb-1">
                                                <div>Là Đảng viên: <Checkbox checked={nhanVien?.isDangVien} disabled /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {
                                        nhanVien?.isDangVien &&
                                        <Row>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Số thẻ đảng viên</div>
                                                    <label>{nhanVien?.ttDangVien.soThe}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Chức vụ đảng</div>
                                                    <label>{nhanVien?.ttDangVien.tenChucVuDang}</label>
                                                </div>
                                            </Col>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Ngày vào đảng</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ttDangVien.ngayKetNap)}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Ngày vào đảng chính thức</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ttDangVien.ngayChinhThuc)}</label>
                                                </div>
                                            </Col>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Tại chi bộ</div>
                                                    <label>{nhanVien?.ttDangVien.noiKetNap}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Tại chi bộ</div>
                                                    <label>{nhanVien?.ttDangVien.noiVaoDangCT}</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            </div>
                    },
                    {
                        key: '3',
                        label: 'Thông tin Đoàn',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px" }}>
                                    <Row>
                                        <Col span="24">
                                            <div className="mb-1">
                                                <div>Là Đoàn viên: <Checkbox checked={nhanVien?.isDoanVien} disabled /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {
                                        nhanVien?.isDoanVien &&
                                        <Row>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Ngày vào Đoàn</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ttDoanVien.ngayVaoDoan)}</label>
                                                </div>
                                                <div className="mb-1">
                                                    <div>Trưởng thành Đoàn: <Checkbox checked={nhanVien?.ttDoanVien.isTruongThanhDoan} disabled /></div>
                                                </div>
                                            </Col>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Nơi kết nạp Đoàn</div>
                                                    <label>{nhanVien?.ttDoanVien.noiKetNapDoan}</label>
                                                </div>
                                                {
                                                    nhanVien?.ttDoanVien.isTruongThanhDoan &&
                                                    <div className="mb-1">
                                                        <div>Ngày trưởng thành Đoàn</div>
                                                        <label>{dateCommon.formatDate(nhanVien?.ttDoanVien.ngayTruongThanhDoan)}</label>
                                                    </div>
                                                }
                                            </Col>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Chức vụ Đoàn</div>
                                                    <label>{nhanVien?.ttDoanVien.tenChucVuDoan}</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            </div>
                    },
                    {
                        key: '4',
                        label: 'Thông tin Quân đội',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px" }}>
                                    <Row>
                                        <Col span="24">
                                            <div className="mb-1">
                                                <div>Là Quân nhân: <Checkbox checked={nhanVien?.isQuanNhan} disabled /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {
                                        nhanVien?.isQuanNhan &&
                                        <Row>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Ngày nhập ngũ</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ttQuanDoi.ngayNhapNgu)}</label>
                                                </div>
                                            </Col>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Ngày xuất ngũ</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ttQuanDoi.ngayXuatNgu)}</label>
                                                </div>
                                            </Col>
                                            <Col span={8}>
                                                <div className="mb-1">
                                                    <div>Nơi nhập ngũ</div>
                                                    <label>{nhanVien?.ttQuanDoi.donViNhapNgu}</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            </div>
                    },
                ]}>
                </Tabs>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <QuaTrinhLamViecVaCongTacBox listCongTac={nhanVien.quaTrinhCongTacs} listLamViec={nhanVien.quaTrinhLamViecs} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <QuaTrinhDaoTaoVaHocVanBox listHocVan={nhanVien.trinhDoHocVans} listDaoTao={nhanVien.quaTrinhDaoTaos} listToBan={nhanVien.toBans} idNhanVien={nhanVien.id} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <ChungChiBox listData={nhanVien.chungChis} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <DanhGiaXepLoaiBox listData={nhanVien.danhGiaXepLoais} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <KhenThuongBox listData={nhanVien.khenThuongs} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <KyLuatBox listData={nhanVien.kyLuats} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <NguoiPhuThuocBox listTaiLieu={nhanVien.dsTaiLieuNguoiPhuThuocs} listData={nhanVien.nguoiPhuThuocs} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row className="mt-1 mb-1">
            <Col span="24">
                <FloatButton.Group
                    trigger="hover"
                    type="primary"
                    style={{ right: 50, bottom: 80 }}
                >
                    {(menu[Links.HoSoCaNhan.SuaDayDu] || menu[Links.HoSoCaNhan.SuaCoBan]) &&
                        <FloatButton
                            tooltip="Chỉnh sửa thông tin"
                            className="hrm-btn-warning"
                            icon={<EditOutlined rev="" />}
                            onClick={() => {
                                menu[Links.HoSoCaNhan.SuaDayDu] ?
                                    navigate(Links.HoSoCaNhan.SuaDayDu) : navigate(Links.HoSoCaNhan.SuaCoBan)
                            }}
                        />}
                    <FloatButton
                        tooltip="In thông tin cá nhân"
                        className="hrm-btn-print"
                        icon={< PrinterOutlined rev="" />}
                        onClick={inBaoCao}
                    />
                    <FloatButton
                        tooltip="Xuất hồ sơ cá nhân"
                        className="hrm-btn-success"
                        onClick={() => setOpenModalXuatFile(true)}
                        icon={<DownloadOutlined rev="" />}
                    />
                </FloatButton.Group>
            </Col>
        </Row>
        <Modal
            title="Tùy chọn xuất hồ sơ cá nhân"
            open={openModalXuatFile}
            onOk={() => xuatBaoCao(nhanVien.id, nhanVien.hoTen, loaiMauXuat)}
            onCancel={() => setOpenModalXuatFile(false)}
            okText="Xuất file"
            cancelText="Hủy"
            centered
        >
            <div style={{ padding: '12px 0' }}>
                <p style={{ marginBottom: 14, fontWeight: 500 }}>Vui lòng chọn mẫu biểu xuất thông tin:</p>
                <Radio.Group onChange={(e) => setLoaiMauXuat(e.target.value)} value={loaiMauXuat} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                    <Radio value={2}>
                        <div>
                            <strong>Sơ yếu lý lịch (Mẫu 2C/TCTW-98 mới)</strong>
                            <div style={{ color: '#666', fontSize: 13 }}>Xuất theo biểu mẫu 2C/TCTW-98 mới (tệp MauThongTinNhanSuMoi.docx)</div>
                        </div>
                    </Radio>
                    <Radio value={1}>
                        <div>
                            <strong>Mẫu thông tin nhân sự (Mẫu cũ)</strong>
                            <div style={{ color: '#666', fontSize: 13 }}>Xuất theo mẫu thông tin hồ sơ nhân sự hiện tại (tệp HoSoNhanSuMoi.docx)</div>
                        </div>
                    </Radio>
                </Radio.Group>
            </div>
        </Modal>
        <div style={{ display: 'none' }}>
            <div ref={componentRef}>
                <InHoSoNhanVienMoi idNhanVien={nhanVien.id} ></InHoSoNhanVienMoi>
            </div>
        </div>
    </section>);
};

export default XemHoSoCaNhan;
